<header class="flex header p-2">
  <h2>{{ productionCardNumber }}</h2>
</header>

<section class="content p-4">
  @if (isEnablingReassignment) {
    <p class="mb-3">
      {{ 'Reassignment_Modal_Enable_Description' | translateWF: 'This will enable reassignment mode for this production card.' }}
    </p>
    <div class="flex flex-col gap-2 mb-3">
      <p-message severity="info" styleClass="w-full">
        {{ 'Reassignment_Modal_Allows_FGT' | translateWF: 'Finished Good Transfers can be created.' }}
      </p-message>
      <p-message severity="info" styleClass="w-full">
        {{ 'Reassignment_Modal_Allows_Reassign' | translateWF: 'Roll reassignment will be permitted.' }}
      </p-message>
      <p-message severity="warn" styleClass="w-full">
        {{ 'Reassignment_Modal_Blocks_Reprocess' | translateWF: 'Reprocessing and dyeing cycles remain blocked.' }}
      </p-message>
    </div>
  } @else {
    <p class="mb-3">
      {{ 'Reassignment_Modal_Close_Description' | translateWF: 'This will return the production card to Closed status. FGT creation and roll reassignment will be blocked again.' }}
    </p>
  }
</section>

<footer>
  <p-button [label]="'Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="onCancel()" />
  @if (isEnablingReassignment) {
    <p-button [label]="'Reassignment_Modal_Enable' | translateWF: 'Enable Reassignment'" severity="warn" icon="pi pi-arrow-right-arrow-left" (click)="onConfirm()" />
  } @else {
    <p-button [label]="'Reassignment_Modal_Return_Closed' | translateWF: 'Return to Closed'" severity="secondary" icon="pi pi-lock" (click)="onConfirm()" />
  }
</footer>
